import { smartContractWalletAddress } from '$lib/home/scwallet/store';
import { get } from 'svelte/store';
import { api } from './utils';

export async function fetchUserPortfolioHistory(startTimestamp: number, endTimestamp: number) {
	const scw = get(smartContractWalletAddress);

	if (!scw || !startTimestamp || !endTimestamp) return;

	const response = await api(
		'get',
		`users/${scw}/portfolio-history?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`
	);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}
